export default "__VITE_PUBLIC_ASSET__2df81115__"